// extracted by mini-css-extract-plugin
export var dropdownIcon = "_mf-6";
export var imgContainer = "_mf-3";
export var menuIcon = "_mf-5";
export var pillWrapper = "_mf-2";
export var pillsContainer = "_mf-1";
export var subscriptionCard = "_mf-0";
export var subscriptionLogo = "_mf-4";